import { BrokenUrlResultConstants } from "../constants/BrokenUrlResultConstants";

/**
 * region for hepers*/

const initialState = {
  pending: false,
  page:0,
  ListResult: {},
  OriginalList: {},
};

export default function BrokenUrlResultReducers(state = initialState, action) {
  switch (action.type) {
    case BrokenUrlResultConstants.FETCH_BROKEN_URL_RESULT_PENDING:
      return {
        ...state,
        pending: true,
      };
    case BrokenUrlResultConstants.FETCH_BROKEN_URL_RESULT_ERROR:
      return {
        ...state,
        error: action.error,
        pending: false,
      };
    case BrokenUrlResultConstants.FETCH_BROKEN_URL_RESULT_GET_LIST_SUCCESS:
      return {
        ...state,
        pending: false,
        ListResult: action.payload,
      };
    case BrokenUrlResultConstants.FETCH_BROKEN_URL_RESULT_SET_PAGE:
      return {
        ...state,
        pending: false,
        page: action.page,
      };
    case BrokenUrlResultConstants.FETCH_BROKEN_URL_SET_APPROVE:
      return {
        ...state,
        pending: false,
      };
    case BrokenUrlResultConstants.FETCH_BROKEN_URL_SET_SELECTED_LIST:
      return {
        ...state,
        pending: false,
        ListResult: action.selectedList,
        OriginalList: action.originalList,
      };
    case BrokenUrlResultConstants.FETCH_BROKEN_URL_SET_ORIGINAL_LIST:
      return {
        ...state,
        pending: false,
        OriginalList: action.originalList,
      };
    default:
      return state;
  }
}
